import React, { useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { Link } from "react-router-dom";
import { FaAngleRight } from 'react-icons/fa';

ChartJS.register(Tooltip, Legend, ArcElement);

function Sip() {
  const [calculationType, setCalculationType] = useState("SIP"); // 'SIP' or 'Lumpsum'
  const [monthlyAmount, setMonthlyAmount] = useState(1000); // For SIP
  const [initialAmount, setInitialAmount] = useState(50000); // For Lumpsum
  const [years, setYears] = useState(10);
  const [rateOfReturn, setRateOfReturn] = useState(12);
  const [futureValue, setFutureValue] = useState(null);
  const [investedAmount, setInvestedAmount] = useState(0);
  const [returns, setReturns] = useState(0);

  const [graphData, setGraphData] = useState({
    labels: ["Invested Amount", "Returns"],
    datasets: [
      {
        data: [0, 0], // Invested amount and returns
        backgroundColor: ["#1E3A8A", "#D1D5DB"], // Dark blue and light gray
      },
    ],
  });

  const calculateInvestment = () => {
    let invested, ret, totalValue;

    if (calculationType === "SIP") {
      const monthlyRate = rateOfReturn / 12 / 100;
      const months = years * 12;
      totalValue =
        (Number(monthlyAmount) * (Math.pow(1 + monthlyRate, months) - 1)) / monthlyRate;
      invested = Number(monthlyAmount) * months;
      ret = totalValue - invested;
    } else {
      totalValue = Number(initialAmount) * Math.pow(1 + rateOfReturn / 100, years);
      invested = Number(initialAmount);
      ret = totalValue - invested;
    }

    setFutureValue(totalValue.toFixed(2));
    setInvestedAmount(invested.toFixed(2));
    setReturns(ret.toFixed(2));

    setGraphData({
      labels: ["Invested Amount", "Returns"],
      datasets: [
        {
          data: [invested, ret],
          backgroundColor: ["#1E3A8A", "#D1D5DB"], // Dark blue and light gray
        },
      ],
    });
  };
  return (
    <React.Fragment>
    <section className="bg-darkBlue pt-20 md:pt-14 text-white min-h-[40vh] md:min-h-[40vh] flex items-center justify-center">
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 items-center justify-center">
            <div className="col-span-12 text-center">
              <div className="py-12">
                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold mb-6 pt-20 md:pt-14">
                SIP / LUMSUM
                </h2>
                <p className="text-sm text-center opacity-80 z-0 flex justify-center items-center">
                  <Link to="/" className="flex items-center text-white hover:text-gray-400">
                    Home
                  </Link>
                  <FaAngleRight className="mx-2" />
                  <Link to="/services/calculator/sip" className="text-white hover:text-gray-400">
                  SIP/LUMPSUM
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    <div className="min-h-screen bg-gray-100 py-10 pt-20">
      <div className="container max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Calculator Section */}
        <div className=" p-8 rounded-lg ">
          {/* Hover Tabs */}
          <div className="flex justify-around mb-6">
            <button
              onClick={() => setCalculationType("SIP")}
              className={`px-6 py-2 font-semibold rounded-t-md ${calculationType === "SIP"
                ? "bg-[#1E3A8A] text-white"
                : "bg-gray-200 text-gray-700"
                }`}
            >
              SIP
            </button>
            <button
              onClick={() => setCalculationType("Lumpsum")}
              className={`px-6 py-2 font-semibold rounded-t-md ${calculationType === "Lumpsum"
                ? "bg-[#1E3A8A] text-white"
                : "bg-gray-200 text-gray-700"
                }`}
            >
              Lumpsum
            </button>
          </div>

          {/* Input Section */}
          {calculationType === "SIP" ? (
            <div className="mb-6">
              <div className="flex items-center justify-between">
                <label className="text-lg font-semibold text-gray-700">
                  Monthly Investment Amount:
                </label>
                <div className="ml-4">

                  <input
                    type="number"
                    min="500"
                    max="50000"
                    value={monthlyAmount}
                    onChange={(e) => setMonthlyAmount(e.target.value)}
                    className="w-24 px-2 py-1 border border-gray-300 rounded-md text-right bg-skyBlue"
                  />
                </div>
              </div>
              <input
                type="range"
                min="500"
                max="50000"
                value={monthlyAmount}
                onChange={(e) => setMonthlyAmount(e.target.value)}
                className="w-full bg-[#1E3A8A] rounded-lg h-2 mt-2"
              />
            </div>
          ) : (
            <div className="mb-6">
              <div className="flex items-center justify-between">
                <label className="text-lg font-semibold text-gray-700">
                  Initial Investment Amount:
                </label>
                <div className="ml-4">

                  <input
                    type="number"
                    min="10000"
                    max="1000000"
                    value={initialAmount}
                    onChange={(e) => setInitialAmount(e.target.value)}
                    className="w-24 px-2 py-1 border border-gray-300 rounded-md text-right bg-skyBlue"
                  />
                </div>
              </div>
              <input
                type="range"
                min="10000"
                max="1000000"
                value={initialAmount}
                onChange={(e) => setInitialAmount(e.target.value)}
                className="w-full bg-[#1E3A8A] rounded-lg h-2 mt-2"
              />
            </div>
          )}

          <div className="mb-6">
            <div className="flex items-center justify-between">
              <label className="text-lg font-semibold text-gray-700">
                Number of Years:
              </label>
              <div className="ml-4">

                <input
                  type="number"
                  min="1"
                  max="30"
                  value={years}
                  onChange={(e) => setYears(e.target.value)}
                  className="w-24 px-2 py-1 border border-gray-300 rounded-md text-right bg-skyBlue"
                />
              </div>
            </div>
            <input
              type="range"
              min="1"
              max="30"
              value={years}
              onChange={(e) => setYears(e.target.value)}
              className="w-full bg-[#1E3A8A] rounded-lg h-2 mt-2"
            />
          </div>

          <div className="mb-6">
            <div className="flex items-center justify-between">
              <label className="text-lg font-semibold text-gray-700">
                Expected Annual Rate of Return (%):
              </label>
              <div className="ml-4">

                <input
                  type="number"
                  min="5"
                  max="20"
                  value={rateOfReturn}
                  onChange={(e) => setRateOfReturn(e.target.value)}
                  className="w-24 px-2 py-1 border border-gray-300 rounded-md text-right bg-skyBlue"
                />
              </div>
            </div>
            <input
              type="range"
              min="5"
              max="20"
              value={rateOfReturn}
              onChange={(e) => setRateOfReturn(e.target.value)}
              className="w-full bg-[#1E3A8A] rounded-lg h-2 mt-2"
            />
          </div>

          <button
            onClick={calculateInvestment}
            className="w-full bg-[#1E3A8A] text-white font-semibold py-3 px-8 rounded-md "
          >
            Calculate
          </button>

          {futureValue && (
            <div className="mt-6 bg-green-100 p-4 rounded-md text-green-800">
              <h3 className="text-lg font-semibold">
                Future Value: ₹{futureValue}
              </h3>
            </div>
          )}
        </div>


        {/* Pie Chart Section */}
        <div className=" p-8 rounded-lg  flex flex-col items-center justify-center">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
            Investment Breakdown
          </h2>
          <div className="w-64 h-64">

            <Pie data={graphData} />
          </div>
          <div className="mt-4 text-center">
            <p className="text-lg font-semibold text-gray-800">
              Invested Amount: ₹{investedAmount}
            </p>
            <p className="text-lg font-semibold text-gray-800">
              Returns: ₹{returns}
            </p>
          </div>
        </div>
      </div>
    </div>
    </React.Fragment>
  );
}

export default Sip;
